import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

// import logoutImg from 'assets/img/icons/spot-illustrations/45.png';

const LogoutContent = ({ layout, titleTag: TitleTag, error, success }) => {
  return (
    <>
      {success ? (
        <>
          <TitleTag>See you soon!</TitleTag>
          <p>
            You are now <br className='d-none d-sm-block' />
            successfully signed out.
          </p>
          <Button
            as={Link}
            color='primary'
            size='sm'
            className='mt-3'
            to={`/login`}
          >
            <FontAwesomeIcon
              icon='chevron-left'
              transform='shrink-4 down-1'
              className='me-1'
            />
            Return to Login
          </Button>
        </>
      ) : error ? (
        <>
          <div>Error: {error}</div>
          <div>
            <Button
              as={Link}
              color='primary'
              size='sm'
              className='mt-3'
              to={`/login`}
            >
              <FontAwesomeIcon
                icon='chevron-left'
                transform='shrink-4 down-1'
                className='me-1'
              />
              Return to Login
            </Button>
          </div>
        </>
      ) : (
        <>
          <div>Signing out...</div>
        </>
      )}
    </>
  );
};

LogoutContent.propTypes = {
  layout: PropTypes.string,
  titleTag: PropTypes.string,
  error: PropTypes.string || PropTypes.null,
  success: PropTypes.bool,
};

LogoutContent.defaultProps = {
  layout: 'simple',
  titleTag: 'h4',
  error: null,
  success: false,
};

export default LogoutContent;
